module.exports = __webpack_public_path__ + "img/icon_map_5_on_110.b41653ac.png";